import { Briefcase, Rocket, Code2, Palette, GraduationCap, Heart, Leaf, Star, Coffee, Compass, Zap } from "lucide-react";
import { AiIcon } from "@/components/ui/ai-icon";

// Built-in avatars (2026-10-03). ids must match AVATAR_PRESETS in
// services/auth-service/app/routes.py.
export const AVATAR_PRESETS = [
  { id: "briefcase", label: "Briefcase", icon: Briefcase, from: "#A67C52", to: "#D4A574" },
  { id: "rocket", label: "Rocket", icon: Rocket, from: "#F47249", to: "#F9A66C" },
  { id: "sparkles", label: "Sparkles", icon: AiIcon, from: "#8B5CF6", to: "#C084FC" },
  { id: "code", label: "Code", icon: Code2, from: "#0EA5E9", to: "#38BDF8" },
  { id: "palette", label: "Palette", icon: Palette, from: "#EC4899", to: "#F9A8D4" },
  { id: "graduation", label: "Graduation cap", icon: GraduationCap, from: "#1E3A8A", to: "#3B82F6" },
  { id: "heart", label: "Heart", icon: Heart, from: "#E11D48", to: "#FB7185" },
  { id: "leaf", label: "Leaf", icon: Leaf, from: "#15803D", to: "#4ADE80" },
  { id: "star", label: "Star", icon: Star, from: "#CA8A04", to: "#FACC15" },
  { id: "coffee", label: "Coffee", icon: Coffee, from: "#78350F", to: "#B45309" },
  { id: "compass", label: "Compass", icon: Compass, from: "#0F766E", to: "#2DD4BF" },
  { id: "zap", label: "Lightning", icon: Zap, from: "#334155", to: "#64748B" },
];

export const presetFor = (avatar) =>
  typeof avatar === "string" && avatar.startsWith("preset:")
    ? AVATAR_PRESETS.find((p) => p.id === avatar.slice(7)) || null
    : null;

// Resize an uploaded image in the browser to a 256px square JPEG data URL,
// well under the server's 200 KB cap.
export function resizeImageFile(file, size = 256) {
  return new Promise((resolve, reject) => {
    if (!/^image\/(png|jpeg|webp)$/.test(file.type)) { reject(new Error("Please choose a PNG, JPG or WebP image.")); return; }
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const side = Math.min(img.width, img.height);
      const canvas = document.createElement("canvas");
      canvas.width = canvas.height = size;
      canvas.getContext("2d").drawImage(img, (img.width - side) / 2, (img.height - side) / 2, side, side, 0, 0, size, size);
      URL.revokeObjectURL(url);
      resolve(canvas.toDataURL("image/jpeg", 0.85));
    };
    img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("That image couldn't be read.")); };
    img.src = url;
  });
}
